import CheckNutriFacts from './CheckNutriFacts';

export default CheckNutriFacts;
